<template>
    <div>
        <top-navbar></top-navbar>
<div>
  

  <div class=" mb-5 background_color" >
      <!-- <h4 class="manage-boder">Manage Customer</h4>  -->
      <h6 class="manage-boder pt-2 font1  decoration">  <router-link class="decoration" to="/"> Home </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><a class="decoration" > Product Sales  </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><a class="decoration" > Product GIN </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span> Manage GIN  </h6>
 
      <div class="container-fluid">
      <div style="border: 0px; padding: 0px; min-height:0px" class="navbar background_color">

       <div class="d-flex flex-column flex-md-row flex-wrap gap-2">

  <!-- Search Input -->
  <b-input-group size="sm" class="w-100" style="max-width: 225px;">
    <b-form-input
      id="filter-input"
      v-model="filter"
      @input="loadMiinventory()"
      type="search"
      placeholder="Search">
    </b-form-input>
  </b-input-group>

  <!-- From Date -->
  <b-input-group class="w-100" style="max-width: 225px;">
    <DatePicker
      v-model="FromDate"
      @input="loadMiinventory()"
      placeholder="From Date"
      ref="fromDateInput"
      style="width: 100%;" />
  </b-input-group>

  <!-- To Date -->
  <b-input-group size="sm" class="w-100" style="max-width: 225px;">
    <DatePicker
      v-model="ToDate"
      @input="loadMiinventory()"
      placeholder="To Date"
      ref="fromDateInput"
      style="width: 100%;" />
  </b-input-group>

  <!-- Showing Info -->
  <div class="ms-md-2 mt-2 mt-md-0">
    <span class="custom-breadcrumb">
      <b>Showing {{ currentPage }} - {{ currentPage * perPage }} of {{ totalRows }} items.</b>
    </span>
  </div>

</div>



<div class="d-grid gap-2 d-md-flex justify-content-md-end">


<!-- <button  @click="squatationCreate()"  class="btn btn-outline-primary btn-sm mb-1 mt-1">  Create Quotations</button> -->


<div>
<b-modal :id="infoModal1.id" 
:header-bg-variant="headerBgVariant"
:header-text-variant="headerTextVariant"

bottom>
<template   #modal-title>

<h3 >Confirm !</h3>



</template>

<div class="d-block text-center">
<h5>Are you sure you want to Confirm ?</h5>
</div>
<hr>

<template   #modal-footer>
<button style="font-size: small;" @click="Confirm(infoModal1.content)" class="mr-1 btn btn-outline-primary btn-sm mb-1 bdr-rad">Yes</button>
<button style="font-size: small;" @click="$bvModal.hide(infoModal1.id)" class="mr-1 btn btn-outline-primary btn-sm mb-1 bdr-rad">No</button>
</template>


</b-modal>


</div>

</div>
</div>



<div  class="card bdr-rad2 mt-1 shadow p-2 ">
<div class="card-body mb-5">

  <div class="d-flex justify-content-center" v-if="isLoading">
  <div class="spinner-border text-primary" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>
<div v-else>
  <!-- <div style="border: 0px; padding: 0px; min-height:20px" class="navbar">
    
    <div class="d-flex  ">
    
    </div>
    <div class="d-flex  ">
      <span class="custom-breadcrumb"><b>Showing {{currentPage}}-{{currentPage*perPage}} of {{totalRows}} items.</b></span>
    </div>
    </div> -->

  <b-table responsive style="font-size: small;"  class="table-hover  "
      :items="all_datas"
      :fields="fields"
      :current-page="currentPage"
      
    
      :filter="filter"
      :filter-included-fields="filterOn"
      :sort-by.sync="sortBy"
      
      
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
  
      show-empty
      small
      @filtered="onFiltered"
    >
   


      <template #cell(name)="row">
        {{ row.value.first }} {{ row.value.last }}
      </template>
      <template #cell(number)="row">
         {{ row.index + 1 === 10 ? currentPage * 10 : (currentPage - 1)*10 + row.index + 1 }} 
      </template>

      <template #cell(actions)="row">
        <div class="dropdown">
  <button class="btn btn-sm btn-outline-primary dropdown-toggle bdr-rad" type="button" data-toggle="dropdown" aria-expanded="false">
    Action
  </button>
  <div class="dropdown-menu bdr-rad">
    <a class="dropdown-item mouse-cursor"  @click="Viewpage(row.item.id)" >View</a>
    <a class="dropdown-item mouse-cursor" @click="Createinvoice(row.item.id)" v-if="row.item.statusvalue==3"> Create Invoice</a>
    <a class="dropdown-item mouse-cursor" @click="Confimmodel(row.item.id)"  v-show="row.item.statusvalue==1" > Confirm</a>
    <a class="dropdown-item mouse-cursor"  @click="updateLoad(row.item.id)" v-show="row.item.statusvalue==1"> Update</a>
    <a class="dropdown-item mouse-cursor" v-show="row.item.statusvalue!=1"  @click="generatePDF(row.item.id)" >Print</a>
   
  </div>
</div>
        <!-- <button  style=" font-size: small;"
         @click="Viewpage(row.item.id)" class="mr-1 btn   btn-outline-primary btn-sm mb-1 bdr-rad">
          View
        </button>
        <button  style=" font-size: small;"
         @click="Createinvoice(row.item.id)" v-if="row.item.statusvalue==3" class="mr-1 btn  btn-outline-primary btn-sm mb-1 bdr-rad">
         Create Invoice
        </button>
      
        <button @click="updateLoad(row.item.id)" v-show="row.item.statusvalue==1" size="sm"  class="btn mr-1 btn btn-outline-primary btn-sm mb-1 font-size_def bdr-rad">
          Update
        </button>

        <button style="font-size: small;"  @click="Confimmodel(row.item.id)"  v-show="row.item.statusvalue==1" size="sm"  class="mr-1 btn btn-outline-primary btn-sm mb-1 font-size_def bdr-rad">
          Confirm
        </button>
        <button  v-show="row.item.statusvalue==1" size="sm"  class="mr-1 btn btn-outline-primary btn-sm mb-1 font-size_def bdr-rad">
          Cancel
        </button>
        <button v-show="row.item.statusvalue!=1"  @click="generatePDF(row.item.id)"  class="btn btn-sm  btn-outline-primary mb-1 bdr-rad"> Print</button> -->
       
      </template>

      <template #row-details="row">
        <b-card>
          <ul>
            <li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value }}</li>
          </ul>
        </b-card>
      </template>
    </b-table>



    <!-- model start -->
    <b-modal   :id="infoModal.id" :title="infoModal.content.SI_issueNum"  hide-footer >
<div class=" ">
<div class="card">
  <div class="card-body">
      <table style="font-size: small; " class="table  table-sm  ">
       
       <tbody >

         <tr >
           <td style="border: 0px;" ><b>Id </b></td>
          <td style="border: 0px;">{{ infoModal.content.idStockIssue }}</td> 
         </tr>
         <tr>
           <td><b>Issue No. </b></td>
          <td>{{ infoModal.content.SI_issueNum }}</td> 
         </tr>
         <tr>
           <td><b>Issued to </b></td>
          <td>{{ infoModal.content.end_user }}</td> 
         </tr>
        
         <tr>
           <td><b>Issued Date </b></td>
          <td>{{ infoModal.content.issues_date }}</td> 
         </tr>
         <tr>
           <td><b>Created Date </b></td>
          <td>{{ infoModal.content.SI_created_date }}</td> 
         </tr>
         <tr>
           <td><b>Remarks </b></td>
          <td>{{ infoModal.content.SI_remarks }}</td> 
         </tr>
         <tr>
           <td><b>Status </b></td>
          <td>{{ infoModal.content.status }}</td> 
         </tr>
        
          
       </tbody>


     </table>

<div   class="d-grid gap-2 d-md-flex justify-content-md-end mb-2">
<button  v-on:click="ViewLoad(infoModal.content.idStockIssue)"   class=" btn custom-btn btn-primary btn-sm mb-1 bdr-rad"> More</button>
</div>
</div>
</div>
</div>  
      
    </b-modal>

    <!-- model end -->
    
      <b-col style="padding-left: 0px;" sm="7" md="2" class="my-1 mb-1">
        <b-pagination v-model="currentPage" pills :total-rows="totalRows" :per-page="perPage" size="sm"></b-pagination>
      </b-col>

      

    </div>
    
    

  

</div>
</div>
</div>
<br><br>
</div>









</div>






        
        <content-footer></content-footer>
    </div>
</template>
<script>
    import jsPDF from 'jspdf';
   import 'jspdf-autotable';
 import axios from 'axios';
 import authService from '@/auth.service';
  import TopNavbar from './../../layout/TopNavbar.vue'
  import ContentFooter from './../../layout/ContentFooter.vue'
  import DatePicker from 'vue2-datepicker';
  import 'vue2-datepicker/index.css';

  export default {
    data() {
      return {
        isLoading: true, 
        access_token:authService.isLoggedIn(),
        userid:authService.isUserid(),
        sortBy: '',
        sortDesc: false,
        sortDirection: 'asc',
        filter: null,
        FromDate: null,
        ToDate: null,
        alldata:{},
        all_code:{},
        details:[],
        total:{},
        filterOn: [],
        totalRows: 1,
        currentPage: 1,
        perPage: 15,
        pageOptions: [5, 10, 15, { value: 100, text: "Show a lot" }],
       
        all_datas:[],
       
        fields: [
          { key: 'number', label: '#', sortable: true, sortDirection: 'desc' },
          { key: 'brand_name', label: 'Brand', sortable: true,  },
          { key: 'SI_issueNum', label: 'GIN No.', sortable: true, sortDirection: 'desc' },
          { key: 'SI_type', label: 'GIN Type', sortable: true,  },
          { key: 'issues_date', label: 'Issued Date', sortable: true  },
          { key: 'C_name', label: 'Customer', sortable: true  },
          { key: 'sales_name', label: 'Sales Person', sortable: true  },
          { key: 'SI_created_date', label: 'Created Date', sortable: true  },
          { key: 'status', label: 'Status', sortable: true  },
          
          { key: 'actions', label: 'Actions', class:'width-custom7', }
        ],

        infoModal: {
          id: 'info-modal',
          title: '',
          content: {},
        },
        infoModal1: {
          id: 'info-modal1',
          title: '',
          content: {},
        },
        variants: ['primary', 'secondary', 'success', 'warning', 'danger', 'info', 'light', 'dark','mycoolor'],
        headerBgVariant: 'mycoolor',
        headerTextVariant: 'light',
      


        
      }

    },
    computed: {
     
    },
    mounted(){
     
      
  this.loadMiinventory();


    },
methods : {

  pdfText(value) {
    if (value === null || value === undefined) return '';
    if (Array.isArray(value)) return value.join(', ');
    if (typeof value === 'object') return JSON.stringify(value);
    return String(value);
  },

  async generatePDF(id) {
      console.log("Amila");
    
    try {
      const { data} = await  axios.get('/istockissue/view?id='+id,{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
       this.alldata = data.alldata
       this.all_code = data.all_code
        this.details = data.details
        this.total = data.total
     
      
    } catch (error) {
      console.log(error.response);
      return;
    }


    const doc = new jsPDF();

function addPageBorders(doc) {
const pageWidth = doc.internal.pageSize.width;
const pageHeight = doc.internal.pageSize.height;

// Set the border style
doc.setDrawColor(71, 144, 255); // Black color
doc.setLineWidth(15); // Border width

// Draw a line at the top of the page
doc.line(0, 0, pageWidth, 0);
// Draw a line at the bottom of the page
doc.line(0, pageHeight, pageWidth, pageHeight);
}
// Update this with your image URL or file path

var img = new Image()
img.src = '/img/evenware-logo.png'
const imageWidth = doc.internal.pageSize.getWidth() - 550; // Adjust 20 if you need margins
const imageHeight = (imageWidth * 3) / 4; // Assuming the aspect ratio is 4:3, adjust as needed

doc.addImage(img, 'png', 10, 13, imageWidth, imageHeight);
doc.setFontSize(18);
doc.setFont('Helvetica', 'bold');
doc.text('GOODS ISSUE NOTE', 105, 30, null, null, 'center');
doc.setFontSize(12);

doc.text('Demonstration System', 10, 45, null, null);

doc.setFont('Helvetica', 'normal');
doc.setFontSize(8);
doc.text('819, North South Road,', 10, 48, null, null);
doc.text('Westwood Central,', 10, 51, null, null);
doc.text('Billingsgate.', 10, 54, null, null);



doc.setFontSize(10);
doc.setFont('Helvetica', 'bold');
doc.text('GIN To:', 85, 45, null, null);
doc.setFontSize(8);
doc.setFont('Helvetica', 'normal');
doc.text(this.pdfText(this.alldata.relatedToCustomer && this.alldata.relatedToCustomer.C_name), 85, 48, null, null);
doc.text(this.pdfText(this.alldata.relatedToCustomer && this.alldata.relatedToCustomer.C_address_line2), 85, 51, null, null);
doc.text(this.pdfText(this.alldata.relatedToCustomer && this.alldata.relatedToCustomer.C_address_line3), 85, 54, null, null);








doc.setFontSize(10);
doc.setFont('Helvetica', 'bold');
doc.text('GIN No:', 200, 45, null, null, 'right');
doc.setFontSize(8);
doc.setFont('Helvetica', 'normal');
doc.text(this.pdfText(this.alldata.SI_issueNum), 200, 49, null, null, 'right');


doc.setFontSize(10);
doc.setFont('Helvetica', 'bold');
doc.text('SO Code:', 200, 53, null, null, 'right');
doc.setFontSize(8);
doc.setFont('Helvetica', 'normal');
doc.text(this.pdfText(this.alldata.relatedToSo && this.alldata.relatedToSo.so_code), 200, 56, null, null, 'right');

doc.setFontSize(10);
doc.setFont('Helvetica', 'bold');
doc.text('Sales Person:', 200, 60, null, null, 'right');
doc.setFontSize(8);
doc.setFont('Helvetica', 'normal');
doc.text(this.pdfText(this.alldata.relatedToSalesPerson && this.alldata.relatedToSalesPerson.name), 200, 63, null, null, 'right');






doc.setFontSize(10);
doc.setFont('Helvetica', 'bold');
doc.text('Date:', 200, 67, null, null, 'right');
doc.setFontSize(8);
doc.setFont('Helvetica', 'normal');
doc.text(this.pdfText(this.alldata.issues_date), 200, 70, null, null, 'right');

const tableData = [
  ['No', 'Product Code', 'Product Description',  'Qty', 'Bin Location']
];


this.details.forEach(detail => {
  tableData.push([
      this.pdfText(detail.no),
      this.pdfText(detail.p_code),
      this.pdfText(detail.P_description),
    
      { content: this.pdfText(detail.qty), styles: { halign: 'right' } },
      this.pdfText(detail.bin_location),
     
   
     
     
     
    
  ]);
});

  // Add table to the PDF
  doc.autoTable({
        startY: 85, // Y position to start the table
        head: [tableData[0]], // Table header
        body: tableData.slice(1),
        addPageContent: function(data) {
    addPageBorders(doc); // Call the function to add page borders
},
styles: {
    font: 'Helvetica',
    fontSize:8,
},
      // Table data excluding header
  });

  
  const tableBottomY = doc.lastAutoTable.finalY;



  doc.setFontSize(9);
    doc.setFont('Helvetica', 'normal');

  



  const blob = doc.output('blob');
    const url = URL.createObjectURL(blob);
    window.open(url, '_blank');




  },




  async Confirm(id) {
       
   
       try {
         const { data} = await  axios.get('/istockissue/confirm?id='+id,{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
          if(data.status==200){
            this.loadMiinventory();
           
            this.$root.$emit('bv::hide::modal', this.infoModal1.id);
        }
         
       } catch (error) {
         console.log(error.response);
       }
     },
     
  async Confimmodel(id){
        this.infoModal1.content = id;
       this.$root.$emit('bv::show::modal', this.infoModal1.id);
      
      },

  ViewLoad(id) {
    
    this.$router.push('/gin/view?id='+id);
  },
  updateLoad(id) {
    
    
    this.$router.push('/gin/update?id='+id);
  },
   Viewpage(id) {
  
  this.$router.push('/gin/view?id='+id);
 
},
async Createinvoice(id){
        this.$router.push('/sinvoice/createsoinvoice?id='+id);
      },



  async info(idgin) {
  
  try {
    const { data} = await  axios.get('/istockissue/view?id='+idgin,{
      headers:{
        'Authorization':'Bearer '+this.access_token,
        'Content-type': 'application/json',
       
      }
     });
     console.log(data);
     this.infoModal.content = data.gin
     this.$root.$emit('bv::show::modal', this.infoModal.id)
    
    
  } catch (error) {
    console.log(error.response);
  }
},

  serchCustom(id) {

this.filterOn = id;
  },

  onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },
  
      async loadMiinventory(page = this.currentPage) {
    console.log(this.access_token);
    try {
      const { data} = await  axios.get('/istockissue/index',{
        params: {
            page: page,
            perPage: this.perPage,
            filter: this.filter,
            FromDate: this.FromDate,
            ToDate: this.ToDate,
          },
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
       this.all_datas = data.all_data;
        this.totalRows = data.total_count;
        this.currentPage = data.page;
        this.isLoading = false;
      
    } catch (error) {
      console.log(error.response);
    }
  },

  pageChanged(page) {
     
     this.loadMiinventory(page);
 },

   

       


 
  


 


},

    components :{
        ContentFooter,
        TopNavbar,
        DatePicker,
    },
  }

</script>
<style scoped>
.modal-footer{
    text-align: right !important;
    display: block;
  }
</style>
